import { render } from "./Upload2.vue?vue&type=template&id=953fc354"
import script from "./Upload2.vue?vue&type=script&lang=js"
export * from "./Upload2.vue?vue&type=script&lang=js"

import "./Upload2.vue?vue&type=style&index=0&id=953fc354&lang=css"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__